import { useState, useRef, useCallback } from 'react';

const DraggableWrapper = ({ children, initialBottom = 28, initialRight = 6 }) => {
  const [position, setPosition] = useState({ bottom: initialBottom * 4, right: initialRight * 4 });
  const [isDragging, setIsDragging] = useState(false);
  const dragRef = useRef(null);
  const startPos = useRef({ y: 0, x: 0 });
  const startOffset = useRef({ bottom: 0, right: 0 });
  const hasMoved = useRef(false);

  const handleTouchStart = useCallback((e) => {
    const touch = e.touches[0];
    startPos.current = { y: touch.clientY, x: touch.clientX };
    startOffset.current = { ...position };
    hasMoved.current = false;
    setIsDragging(true);
  }, [position]);

  const handleTouchMove = useCallback((e) => {
    if (!isDragging) return;
    const touch = e.touches[0];
    const deltaY = startPos.current.y - touch.clientY;
    const deltaX = startPos.current.x - touch.clientX;

    if (Math.abs(deltaY) > 5 || Math.abs(deltaX) > 5) {
      hasMoved.current = true;
    }

    const newBottom = Math.max(16, Math.min(window.innerHeight - 60, startOffset.current.bottom + deltaY));
    const newRight = Math.max(16, Math.min(window.innerWidth - 60, startOffset.current.right + deltaX));

    setPosition({ bottom: newBottom, right: newRight });
  }, [isDragging]);

  const handleTouchEnd = useCallback((e) => {
    setIsDragging(false);
    if (hasMoved.current) {
      e.preventDefault();
    }
  }, []);

  return (
    <div
      ref={dragRef}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      style={{
        position: 'fixed',
        bottom: `${position.bottom}px`,
        right: `${position.right}px`,
        zIndex: 40,
        touchAction: 'none',
      }}
      className={isDragging ? 'opacity-80 scale-110' : 'transition-transform'}
    >
      {children}
    </div>
  );
};

export default DraggableWrapper;
